export default "__VITE_ASSET__393cf67d__"